module.exports = __webpack_public_path__ + "static/media/docIconGrey.28d47adc.svg";